<template>
  <v-container :style="heightOverflow + ' margin: 0px; padding: 0px; min-width: 200px; max-width: 100%; '">
    <template v-if="(user.plano && user.plano.id_empresa === null) || user.plano === null">
      <Planos/>
      <MinhasAssinaturas/>
    </template>
    <v-layout
      justify-center>
      <v-flex
        xs12
        sm12
        md12
      >
        <material-card
          :title="strings[idioma].nossos_planos"
          color="indigo lighten-5 font-weight-bold"
        >
          <iframe
            :style="'border: 0px;margin-top:-60px ;width: ' + widthCard"
            :src="temSejaPremiumParceiro ? empresaParceiraInfo.seja_premium_link : 'https://brcorte.com.br/site/seja-premium.php?tipo=' + user.perfil + '&lang=' + (idioma === 0 ? 'pt' : 'en')"
            allow="microphone; camera; speech; script"
            remote="true"
            sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
            height="7300px"
            data-origwidth=""
            data-origheight="7300px"/>
          <template v-if="false">
            <table class="v-table">
              <thead>
                <tr>
                  <th style="width: 300px"/>
                  <th class="subheading font-weight-light">Comum</th>
                  <th class="subheading font-weight-light">Premium</th>
                </tr>
              </thead>
              <tbody class="text-xs-center">
                <tr>
                  <th class="text-xs-left font-weight-light subheading">Acesso ao Resumo de Alimentos</th>
                  <td>
                    <v-icon color="success">mdi-check</v-icon>
                  </td>
                  <td>
                    <v-icon color="success">mdi-check</v-icon>
                  </td>
                </tr>
                <tr>
                  <th class="text-xs-left font-weight-light subheading">Calcular Dietas</th>
                  <td>
                    <v-icon color="success">mdi-check</v-icon>
                  </td>
                  <td>
                    <v-icon color="success">mdi-check</v-icon>
                  </td>
                </tr>
                <tr>
                  <th class="text-xs-left font-weight-light subheading">Cálculo de Predição</th>
                  <td>
                    <v-icon color="success">mdi-check</v-icon>
                  </td>
                  <td>
                    <v-icon color="success">mdi-check</v-icon>
                  </td>
                </tr>
                <tr>
                  <th class="text-xs-left font-weight-light subheading">Gerar Relatórios</th>
                  <td>
                    <v-icon color="success">mdi-check</v-icon>
                  </td>
                  <td>
                    <v-icon color="success">mdi-check</v-icon>
                  </td>
                </tr>
                <tr>
                  <th class="text-xs-left font-weight-light subheading">Calcular Exigências</th>
                  <td>
                    <v-icon color="success">mdi-check</v-icon>
                  </td>
                  <td>
                    <v-icon color="success">mdi-check</v-icon>
                  </td>
                </tr>
                <tr>
                  <th class="text-xs-left font-weight-light subheading">Reotimizar Dietas (Soluções alternativas)</th>
                  <td>
                    <v-icon color="error">mdi-close</v-icon>
                  </td>
                  <td>
                    <v-icon color="success">mdi-check</v-icon>
                  </td>
                </tr>
                <tr>
                  <th class="text-xs-left font-weight-light subheading">Conversão Fácil de Dieta para Predição</th>
                  <td>
                    <v-icon color="error">mdi-close</v-icon>
                  </td>
                  <td>
                    <v-icon color="success">mdi-check</v-icon>
                  </td>
                </tr>
                <tr>
                  <th class="text-xs-left font-weight-light subheading">Edição de Exigências</th>
                  <td>
                    <v-icon color="error">mdi-close</v-icon>
                  </td>
                  <td>
                    <v-icon color="success">mdi-check</v-icon>
                  </td>
                </tr>
                <tr>
                  <th class="text-xs-left font-weight-light subheading">Fixar Proporção V:C</th>
                  <td>
                    <v-icon color="error">mdi-close</v-icon>
                  </td>
                  <td>
                    <v-icon color="success">mdi-check</v-icon>
                  </td>
                </tr>
                <tr>
                  <th class="text-xs-left font-weight-light subheading">Edição de Alimentos</th>
                  <td>
                    <v-icon color="error">mdi-close</v-icon>
                  </td>
                  <td>
                    <v-icon color="success">mdi-check</v-icon>
                  </td>
                </tr>
                <tr>
                  <th class="text-xs-left font-weight-light subheading">Criação de Alimentos Pessoais</th>
                  <td>
                    <v-icon color="error">mdi-close</v-icon>
                  </td>
                  <td>
                    <v-icon color="success">mdi-check</v-icon>
                  </td>
                </tr>
                <tr>
                  <th class="text-xs-left font-weight-light subheading">Salvar Dados na Nuvem</th>
                  <td>
                    <v-icon color="error">mdi-close</v-icon>
                  </td>
                  <td>
                    <v-icon color="success">mdi-check</v-icon>
                  </td>
                </tr>
                <tr>
                  <th class="text-xs-left font-weight-light subheading">Relatórios Pessoais</th>
                  <td>
                    <v-icon color="error">mdi-close</v-icon>
                  </td>
                  <td>
                    <v-icon color="success">mdi-check</v-icon>
                  </td>
                </tr>
                <tr>
                  <th class="text-xs-left font-weight-light subheading">Suporte Técnico</th>
                  <td>
                    <v-icon color="error">mdi-close</v-icon>
                  </td>
                  <td>
                    <v-icon color="success">mdi-check</v-icon>
                  </td>
                </tr>
                <tr>
                  <th class="text-xs-left font-weight-light subheading">Acesso à Ferramentas de Usabilidade</th>
                  <td>
                    <v-icon color="error">mdi-close</v-icon>
                  </td>
                  <td>
                    <v-icon color="success">mdi-check</v-icon>
                  </td>
                </tr>
                <tr>
                  <th class="text-xs-left font-weight-light subheading">Acesso Antecipado as Ferramentas de Pesquisas mais Recentes</th>
                  <td>
                    <v-icon color="error">mdi-close</v-icon>
                  </td>
                  <td>
                    <v-icon color="success">mdi-check</v-icon>
                  </td>
                </tr>
                <tr>
                  <th/>
                  <td>Grátis</td>
                  <td>

                    <v-layout
                      style="padding: 10px;"
                      justify-center>
                      <v-flex

                        sm3
                        md12>
                        <div style="min-height: 50px">
                          <b style="font-size: 15px">R$ 40,00/mês</b><br>
                        </div>
                        <input
                          id="mes"
                          v-model="pagamento"
                          type="radio"
                          value="0"
                          name="pagamento">
                        <label for="mes"> Mensal</label><br>
                      </v-flex>
                      <v-flex
                        sm3
                        md12>
                        <div style="min-height: 50px">
                          <span><s>R$ 479,99/ano</s> por</span><br>
                          <b style="font-size: 15px">R$ 441,60/ano</b><br>
                        </div>
                        <input
                          id="ano"
                          v-model="pagamento"
                          type="radio"
                          value="1"
                          name="pagamento">
                        <label for="ano"> Anual</label><br>
                      </v-flex>
                    </v-layout>
                  </td>
                </tr>
                <tr>
                  <th/>
                  <td>
                    <v-btn
                      class="subheading white--text font-weight-light"
                      round
                      large
                      color="grey"
                      disabled
                    >Versão Padrão</v-btn>
                  </td>
                  <td>
                    <a
                      v-show="false"
                      :href="linkMP"
                      mp-mode="dftl"
                      name="MP-payButton"
                      class="blue-ar-l-rn-none">Assinar</a>

                    <v-btn
                      class="subheading white--text font-weight-light"
                      round
                      large
                      color="cyan"
                      @click="solicitacao"
                    >Solicite Premium</v-btn>
                  </td>
                </tr>
              </tbody>
            </table>
            <v-layout>
              <v-flex>
                <h2 style=" text-align: center; color: blue">ou faça um PIX!</h2>
                <p style=" text-align: center; color: blue">CNPJ: {{ chavePix }}</p>
              </v-flex>
            </v-layout>
            <v-layout style=" text-align: center">
              <v-flex xs4>
                <h2>Anual</h2>
                <img :src="'https://chart.googleapis.com/chart?chs=200x250&cht=qr&chl='+brcodeAnual">
                <p>R$441,60</p>
              </v-flex>
              <v-flex xs4>
                <h2>Semestral</h2>
                <img :src="'https://chart.googleapis.com/chart?chs=200x250&cht=qr&chl='+brcodeSemestral">
                <p>R$228,00</p>

              </v-flex>
              <v-flex xs4>
                <h2>Trimestral</h2>
                <img :src="'https://chart.googleapis.com/chart?chs=200x250&cht=qr&chl='+brcodeTrimestral">
                <p>R$116,40</p>

              </v-flex>
            </v-layout>
          </template>
          <v-layout
            v-if="!temSejaPremiumParceiro"
            style="margin:auto; max-width: 700px;">
            <div
              style="text-align: center"
              v-html="strings[idioma].seja_premium_comprovante"/>
          </v-layout>

        </material-card>
        <material-card v-if="!temSejaPremiumParceiro">
          <v-layout
            justify-center
            style="padding: 50px;">
            <v-flex xs8>
              <h3>{{ strings[idioma].seja_premium_msg }}</h3>
            </v-flex>
            <v-flex xs4>
              <v-btn
                class="subheading white--text font-weight-light"
                round
                large
                style="width: 320px; padding: 25px;margin-top: 10px; margin-left: 10px;"
                color="cyan"
                @click="orcamento()"
              >{{ strings[idioma].seja_premium_faca_orcamento }}</v-btn>
            </v-flex>
          </v-layout>
        </material-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="dialog"
      width = "350">
      <v-card style="padding: 20px;">
        <h4>Preço: {{ preco.toFixed(2).replace('.', strings[idioma].separador_float) }}</h4>
        <h4>Meses: {{ meses }} </h4>
        <h4>Chave PIX (CNPJ): {{ chavePix }}</h4>
        <v-layout>
          <span style="text-align: center; color: blue; font-size: 12pt!important;">Envie o comprovante com o seu <span style="font-weight: bold; color: red;">e-mail de login</span> para <span style="font-weight: bold">contato@brcorte.com.br</span> <br>ou pelo Whatsapp <span style="font-weight: bold">(37) 99982-0856</span></span>
        </v-layout>
      </v-card>
    </v-dialog>

  </v-container>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import MinhasAssinaturas from './user/MinhasAssinaturas'
import Planos from './user/Planos'
(function () {
  function $MPC_load () {
    window.$MPC_loaded !== true && (function () {
      var s = document.createElement('script')
      s.type = 'text/javascript'
      s.async = true
      s.src = document.location.protocol + '//secure.mlstatic.com/mptools/render.js'
      var x = document.getElementsByTagName('script')[0]
      x.parentNode.insertBefore(s, x)
      window.$MPC_loaded = true
    })()
  }
  window.$MPC_loaded !== true ? (window.attachEvent ? window.attachEvent('onload', $MPC_load) : window.addEventListener('load', $MPC_load, false)) : null
})()
export default {
  components: {
    MinhasAssinaturas,
    Planos
  },
  data: () => ({
    empresaParceiraInfo: null,
    pagamentoAnual: false,
    pagamentoMensal: true,
    pagamento: 0,
    preco: 441.60,
    meses: 12,
    dialog: false,
    chavePix: '41.091.007/0001-43',
    brcodeTrimestral: '00020126610014BR.GOV.BCB.PIX0114410910070001430221ASSINATURA_TRIMESTRAL5204000053039865406116.405802BR5925BR CORTE SOLUCOES EM PECU6006POMPEU62410503***50300017BR.GOV.BCB.BRCODE01051.0.063049849',
    brcodeAnual: '00020126560014BR.GOV.BCB.PIX0114410910070001430216ASSINATURA_ANUAL5204000053039865406441.605802BR5925BR CORTE SOLUCOES EM PECU6006POMPEU62410503***50300017BR.GOV.BCB.BRCODE01051.0.06304B8F6',
    brcodeSemestral: '00020126600014BR.GOV.BCB.PIX0114410910070001430220ASSINATURA_SEMESTRAL5204000053039865406228.005802BR5925BR CORTE SOLUCOES EM PECU6006POMPEU62410503***50300017BR.GOV.BCB.BRCODE01051.0.06304F98E',
    brcodeMensal: '00020126570014BR.GOV.BCB.PIX0114410910070001430217ASSINATURA_MENSAL520400005303986540540.005802BR5925BR CORTE SOLUCOES EM PECU6006POMPEU62410503***50300017BR.GOV.BCB.BRCODE01051.0.063048464'
  }),
  computed: {
    ...mapState('app', ['idioma', 'headersComposicaoRacao', 'strings', 'user']),
    temSejaPremiumParceiro () {
      return !!(this.empresaParceiraInfo && this.empresaParceiraInfo.seja_premium_link)
    },
    brcode () {
      let desc = 'ASSINATURA_' + ((this.pagamentoAnual) ? 'ANUAL' : 'MENSAL') + '_' + this.user.id
      let countDesc = desc.length
      return '00020126610014BR.GOV.BCB.PIX01144109100700014302' + countDesc + '' + desc + '5204000053039865406' + this.preco + '5802BR5925BR CORTE SOLUCOES EM PECU6006POMPEU62410503***50300017BR.GOV.BCB.BRCODE01051.0.0630458C3'
    },
    linkMP () {
      this.pagamento = parseInt(this.pagamento)
      if (this.pagamento === 0) {
        return 'https://www.mercadopago.com.br/subscriptions/checkout?preapproval_plan_id=2c9380847981e6d40179a4e623670c6d'
      } else if (this.pagamento === 1) {
        return 'https://www.mercadopago.com.br/subscriptions/checkout?preapproval_plan_id=2c9380847981e6b00179a40dcd8d0c20'
      }
    },
    widthCard () {
      return (!this.isMobile) ? String(this.$vuetify.breakpoint.width - 300) + 'px' : String(this.$vuetify.breakpoint.width) + 'px'
    },
    heightCard () {
      return String(this.$vuetify.breakpoint.height - 289) + 'px'
    },
    heightOverflow () {
      return (
        'max-height: ' +
            String(this.$vuetify.breakpoint.height - 50) +
            'px; overflow: auto;'
      )
    },
    isMobile () {
      return (this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.md)
    }
  },
  watch: {
    pagamento (val) {
      console.log(val)
    }
  },
  async created () {
    if (this.user.plano && this.user.plano.id_empresa !== null) {
      await this.getInfoEmpresa(this.user.plano.id_empresa)
    }
  },

  methods: {
    async getInfoEmpresa (idEmpresa) {
      try {
        let res = await this.$getInfoEmpresa(idEmpresa)
        this.empresaParceiraInfo = res
      } catch (error) {
        this.empresaParceiraInfo = null
        console.log(error)
      }
    },
    orcamento () {
      let title = 'Orçamento'
      let msg = '<h3>Entre em contato:</h3><a href="https://api.whatsapp.com/send?phone=5531971857786&text=Gostaria%20de%20um%20Or%C3%A7amento%20para%20Empresa%20ou%20Consultor">Whatsapp: (37) 99982-0856</a> (Segunda a Sexta - 08 às 18 hrs*) *Horário de Brasília<br><a href="mailto:contato@brcorte.com.br">E-Mail: contato@brcorte.com.br</a>'
      this.$store.commit('openOKModal', { title, msg })
    },
    solicitacao () {
      // this.getToken()
      let meses = 12
      if (parseInt(this.pagamento) === 0) {
        meses = prompt('Quantos meses?')
        if (!meses || isNaN(meses) || isNaN(parseInt(meses)) || parseInt(meses) > 24 || parseInt(meses) < 1) {
          alert('Não é possivel solicitar premium para essa quantidade de meses')
          return
        }
        this.preco = 40 * meses
      }
      meses = parseInt(meses)
      this.meses = meses
      let premium = {
        qtd_meses: meses,
        id_pessoa: this.user.id,
        aprovado: -1
      }
      this.dialog = true
      this.axios.post('users/salveSolicitacoesPremium', { premium }).then(_ => {
        alert('Solicitação Enviada. Aguarde contato por e-mail ou telefone.')
      })
    }
  }
}
</script>
